import React from 'react';

import { View, Image, Pressable, ActivityIndicator, StyleSheet, Platform } from 'react-native';

import OPComponent from './op_component';
import ZoomableImageView from './zoomable_image_view';
import { COLOR } from '../../constants/styles';

export const IMAGE_WIDTH = 250.0;
export const IMAGE_HEIGHT = 150.0;

export default class ImageView extends OPComponent {
  constructor(props) {
    super(props);

    this.unMounted = true;

    this.state = {
      loading: (!props.imageUri && props.loading) || null,
      imageUri: props.imageUri || null,
      imageError: false,
    };

    this.zoomableRef = React.createRef();
  }

  componentDidMount() {
    this.unMounted = false;
  }
  componentWillUnmount() {
    this.unMounted = true;
  }

  componentDidUpdate(prevProps) {
    if (this.props.loading !== prevProps.loading || this.props.imageUri !== prevProps.imageUri) {
      this.setState({
        loading: this.props.loading,
        imageUri: this.props.imageUri,
      });
    }
  }

  resetZoomSize() {
    this.zoomableRef.current?.resetZoomSize();
  }

  setImageUri(imageUri) {
    this.setState({ imageUri, loading: false });
  }

  fixupImageUri(imageUri) {
    if (!imageUri) return imageUri;

    // web has :// for http:// but doesn't need to have file:/// appended
    if (Platform.OS !== 'web' && imageUri.indexOf('://') === -1) {
      imageUri = `file:///${imageUri}`;
    }

    return imageUri;
  }

  render() {
    const { width, height, spinnerColor, flexSize, onImageError, onSwipeHorizontal } = this.props;
    let { loading, imageUri } = this.state;
    imageUri = this.fixupImageUri(imageUri);

    const sizeStyle = {
      width: width || IMAGE_WIDTH,
      height: height || IMAGE_HEIGHT,
    };

    // loading = true;
    // console.info(
    //   'ImageView render ' + imageUri,
    //   width,
    //   height,
    //   spinnerColor,
    //   flexSize
    // );
    if (loading) {
      return (
        <View style={[styles.imageContainer, styles.activityContainer, sizeStyle]}>
          <ActivityIndicator animating={true} size="large" color={spinnerColor || 'black'} />
        </View>
      );
    }

    if (this.state.imageError || !imageUri) {
      return (
        <View style={[styles.imageContainer, sizeStyle]}>
          <Image
            style={styles.imageMissingIcon}
            source={require('../../../resources/icon-no-image.png')}
          />
          {!!this.props.loadingIndicator && (
            <View
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                justifyContent: 'center',
                backgroundColor: COLOR.overlay,
              }}
            >
              <ActivityIndicator animating={true} size="large" color={'white'} />
            </View>
          )}
        </View>
      );
    }

    if (flexSize) {
      return (
        <ZoomableImageView
          ref={this.zoomableRef}
          imageUri={imageUri}
          onClose={this.props.onClose}
          onError={(e) => {
            if (!this.unMounted) this.setState({ imageError: true });
            onImageError && onImageError(e);
          }}
          onSwipeHorizontal={onSwipeHorizontal}
        />
      );
    }

    return (
      <Pressable
        onPress={this.props.onPress}
        style={[styles.imageContainer, sizeStyle]}
        disabled={!this.props.onPress}
      >
        <Image
          style={[styles.messageImage, sizeStyle]}
          source={{ uri: imageUri }}
          resizeMode={this.props.resizeMode || 'cover'}
          onError={(e) => {
            if (!this.unMounted) this.setState({ imageError: true });
            onImageError && onImageError(e);
          }}
        />
        {!!this.props.loadingIndicator && (
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              justifyContent: 'center',
              backgroundColor: COLOR.overlay,
            }}
          >
            <ActivityIndicator animating={true} size="large" color={'white'} />
          </View>
        )}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  messageImage: {},
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  imageMissingIcon: {
    tintColor: COLOR.accent,
  },
  activityContainer: {
    paddingTop: 4,
    paddingLeft: 4,
  },
});
